import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Col, Row } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { ColDef } from "ag-grid-enterprise";
import {
  WorkInProgressModel,
  WorkInprogressModelDetails,
} from "../../types/WorkInProgressModel";
import {
  postWorkInProgressData,
  deleteWorkInProgressData,
} from "../../api/workInProgressApi/workInProgressApi";
import moment from "moment";
import PushPinIcon from "@mui/icons-material/PushPin";
import { UserGridPreferenceModel } from "../../types/UserGridPreferenceModel";
import {
  getUserGridPreference,
  saveUserGridPreference,
} from "../../api/userDataApi/userGridPreferenceAPI";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.min.css";
import ExcelIcon from "../../assets/images/ExcelExport.png";
import "../../config/colors.css";
import { useSnackbar } from "../Common/SnackbarContext";
import { useLoader } from "../../context/LoaderContext";
import { appSettings } from "../../config/appSetting";
import { FormatDate } from "../Common/CommonMethods";
import LocalStorageUtil from "../../utils/localStorage";

const YesNoCellRenderer = ({ value }: { value: any }) => {
  const displayValue = value === true || value === "true" ? "true" : "false"; // NO USE will always be false
  return <span>{displayValue}</span>;
};

const AssetMetaDataCellRenderer = ({ value }: { value: any }) => {
  return (
    <div style={{ whiteSpace: "normal", overflow: "hidden" }}>{value}</div>
  );
};

const WorkInProgress = () => {
  const { setLoading } = useLoader();
  const { showSnackbar } = useSnackbar();
  const pageSizeSelector = appSettings.agGridPageSizeSelector;
  const defaulPageSize = appSettings.agGridDefaulPageSize;
  const [selectedAgeDays, setSelectedAgeDays] = useState<string>("0");
  let ageDay: number | null = 0;
  const [, setGridPreferences] = useState<any>();//NOSONAR
  const [rowData, setRowData] = useState<WorkInProgressModel[]>([]);
  const gridRef = useRef<AgGridReact>(null);
  const [gridRecordExist, setGridRecordExist] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [columnDefs] = useState<ColDef[]>([
    {
      headerName: "#",
      width: 70,
      sortable: false,
      filter: false,
      resizable: false,
      colId: "col1",
      hide: false,
      autoHeight: true,
      pinned: "left",
      lockPinned: true,
      suppressSizeToFit: false,
      enableRowGroup: false,
      valueGetter: (params) => {
        return params.node ? (params.node.rowIndex ?? 0) + 1 : 0;
      },
    },

    {
      headerName: "IngestionTime",
      field: "ingestionTime",
      width: 170,
      hide: false,
      colId: "col3",
      autoHeight: true,
      cellClass: "dateFormat",
      enableRowGroup: true,
      filter: true,
      valueFormatter: (params) => {
        return params.value ? FormatDate(params.value) : "";
      },
    },
    {
      headerName: "AssetName",
      field: "assetName",
      tooltipField: "assetName",
      autoHeight: true,
      hide: false,
      enableRowGroup: true,
      filter: true,
      colId: "col4",
    },
    {
      headerName: "ActionCode",
      field: "actionCode",
      tooltipField: "actionCode",
      width: 150,
      hide: false,
      autoHeight: true,
      enableRowGroup: true,
      filter: true,
      colId: "col5",
    },
    {
      headerName: "Reason",
      field: "reason",
      tooltipField: "reason",
      width: 235,
      hide: false,
      enableRowGroup: true,
      filter: true,
      colId: "col6",
    },
    {
      headerName: "Cusip",
      field: "cusip",
      tooltipField: "cusip",
      width: 113,
      hide: false,
      autoHeight: true,
      enableRowGroup: true,
      filter: true,
      colId: "col7",
    },
    {
      headerName: "DocTypeCode",
      field: "documentTypeCode",
      tooltipField: "documentTypeCode",
      width: 170,
      hide: false,
      autoHeight: true,
      enableRowGroup: true,
      filter: true,
      colId: "col8",
    },
    {
      headerName: "AssetMetaDataLineitem",
      field: "assetMetadataLineitem",
      tooltipField: "assetMetadataLineitem",
      width: 380,
      hide: false,
      enableRowGroup: true,
      filter: true,
      colId: "col9",
      cellRenderer: AssetMetaDataCellRenderer,
    },
    {
      headerName: "AssetMetaDataName",
      field: "assetMetaDataName",
      tooltipField: "assetMetaDataName",
      width: 220,
      hide: false,
      autoHeight: true,
      enableRowGroup: true,
      filter: true,
      colId: "col10",
    },
    {
      headerName: "AssetMetaDataLocation",
      field: "assetMetaDataLocation",
      tooltipField: "assetMetaDataLocation",
      width: 250,
      hide: false,
      autoHeight: true,
      enableRowGroup: true,
      filter: true,
      colId: "col11",
    },
    {
      headerName: "AssetLocation",
      field: "assetLocation",
      tooltipField: "assetLocation",
      hide: false,
      autoHeight: true,
      enableRowGroup: true,
      filter: true,
      colId: "col12",
    },
    {
      headerName: "AgeDays",
      field: "age",
      tooltipField: "age",
      width: 150,
      hide: false,
      autoHeight: true,
      enableRowGroup: true,
      filter: true,
      colId: "col13",
    },
    {
      headerName: "IsIngested",
      field: "isIngested",
      tooltipField: "isIngested",
      hide: false,
      autoHeight: true,
      enableRowGroup: true,
      filter: true,
      colId: "col14",
      cellRenderer: YesNoCellRenderer,
    },
    {
      headerName: "IsDeleted",
      field: "isDeleted",
      tooltipField: "isDeleted",
      hide: false,
      autoHeight: true,
      enableRowGroup: true,
      filter: true,
      colId: "col15",
      cellRenderer: YesNoCellRenderer,
    },
    {
      headerName: "IsArchived",
      field: "isArchived",
      tooltipField: "isArchived",
      hide: false,
      autoHeight: true,
      enableRowGroup: true,
      filter: true,
      colId: "col16",
      cellRenderer: YesNoCellRenderer,
    },
  ]);

  const handleConfirmDelete = async () => {
    setIsDialogOpen(false); 
    await handleDelete();
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleDeleteClick = () => {
    debugger;
    setIsDialogOpen(true);
  };

  const ageDays = [
    {
      value: "0",
      label: "0",
    },
    {
      value: "All",
      label: "All",
    },
  ];

  const getData = useCallback(async (params: WorkInprogressModelDetails) => {
    setLoading(true);
    try {
      const workInProgressDetails = await postWorkInProgressData(params);
      if (workInProgressDetails?.workInprogressModelDetails?.length > 0) {
        setGridRecordExist(true);
        setRowData(workInProgressDetails.workInprogressModelDetails);
        const gridPreferences = await getUserGridPreferencesData();
        if (gridPreferences) {
          applyGridPreferences(gridPreferences);
          setGridPreferences(gridPreferences);
        }
        showSnackbar("Grid state applied successfully.");
      } else {
        showSnackbar("0 records found");
        setGridRecordExist(false);
        setRowData([]);
      }
    } catch (error) {
      showSnackbar("Error fetching data", true);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch data On page load
  useEffect(() => {
    const params: WorkInprogressModelDetails = {
      AgeDays: 0,
      workInprogressModelDetails: [],
      UnmatchedAssetNamesDelete: [],
      UnmatchedAssetIds: [],
      ModifiedBy: 0,
      contextName: LocalStorageUtil.getItem("contextName")?.toString(),
    };
    getData(params);
  }, [getData]);

  // Reapply grid state on component update
  useEffect(() => {
    const reapplyGridState = async () => {
      const gridPreferences = await getUserGridPreferencesData();
      if (gridPreferences) {
        applyGridPreferences(gridPreferences);
      }
    };
    reapplyGridState();
  }, [rowData]);

  //Apply grid preferences
  const applyGridPreferences = (gridPreferences: any) => {
    if (gridPreferences) {
      try {
        const gridState = JSON.parse(gridPreferences);
        if (gridRef.current) {
          gridRef.current.api.applyColumnState({
            state: gridState,
            applyOrder: true,
          });

          gridRef.current.api.setFilterModel(gridState);
          gridRef.current.api.applyColumnState(gridState);
        }
      } catch (error) {
        showSnackbar("Error parsing grid preferences", true);
      }
    } else {
      showSnackbar("Grid state not found for this account.");
    }
  };

  // Export data to excel
  const handleExport = () => {
    if (gridRef.current) {
      const predefinedColumns = [
        "col1",
        "col3",
        "col4",
        "col5",
        "col6",
        "col7",
        "col8",
        "col9",
        "col10",
        "col11",
        "col12",
        "col13",
        "col14",
        "col15",
        "col16",
      ]; // Define the columns to be exported
      
      gridRef.current.api.exportDataAsExcel({
        fileName:
          "WorkInProgressReports_" + moment().format("YYYYMMDD") + ".xlsx",
        sheetName: "WorkInProgress Report",
        columnKeys: predefinedColumns,
        processCellCallback: function (params) {
          return params.value;
        },
      });
    }
  };

  //Clear button
  const handleClear = () => {
    setSelectedAgeDays("0");
  };

  //Delete button
  const handleDelete = async () => {
    if (gridRef.current) {
      const selectedNodes = gridRef.current.api
        .getSelectedNodes()
        .filter((node) => node.displayed);
      if (selectedNodes.length === 0) {
        showSnackbar("Please select the records to delete", true);
      } else {
        const params: WorkInprogressModelDetails = {
          AgeDays: 0,
          workInprogressModelDetails: [],
          UnmatchedAssetNamesDelete: [],
          UnmatchedAssetIds: selectedNodes.map((node) => node.data.assetID),
          ModifiedBy: 0,
          contextName: LocalStorageUtil.getItem("contextName")?.toString(),
        };
        const deleteData = await deleteWorkInProgressData(params);
        if (deleteData) {
          const params: WorkInprogressModelDetails = {
            AgeDays: parseInt(selectedAgeDays), //0,
            workInprogressModelDetails: [],
            UnmatchedAssetNamesDelete: [],
            UnmatchedAssetIds: [],
            ModifiedBy: 0,
            contextName: LocalStorageUtil.getItem("contextName")?.toString(),
          };
          getData(params);
          showSnackbar("Selected records are deleted successfully");
        }
      }
    }
  };

  //Save grid preferences
  const handleSaveGridPreferences = async () => {
    if (gridRef.current) {
      const gridState = gridRef.current.api.getColumnState();
      const userGridPreference: UserGridPreferenceModel = {
        Area: "WorkInProgress",
        UserID: Number(LocalStorageUtil.getItem("userId")),
        BusinessUnitID: Number(LocalStorageUtil.getItem("businessUnitId")),
        ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
        GridBlob: JSON.stringify(gridState),
        LastModifiedBy: "DocDistro-UserGridPreferencesAPI",
        LastModifiedDate: new Date().toISOString(),
      };
      try {
        const workInProgressModelInfo = await saveUserGridPreference(
          userGridPreference
        );
        if (workInProgressModelInfo) {
          showSnackbar("Grid state successfully saved.");
        }
      } catch (error) {
        showSnackbar("Error saving grid preferences", true);
      }
    }
  };

  //Get grid preferences
  const getUserGridPreferencesData = async () => {
    setLoading(true);
    try {
      const workInProgressModelInfo: UserGridPreferenceModel = {
        Area: "WorkInProgress",
        UserID: Number(LocalStorageUtil.getItem("userId")),
        BusinessUnitID: Number(LocalStorageUtil.getItem("businessUnitId")),
        ContextName: localStorage
          .getItem("contextName")
          ?.toString()
          ?.toString(),
        GridBlob: "",
        LastModifiedBy: "DocDistro-UserGridPreferencesAPI",
        LastModifiedDate: new Date().toISOString(),
      };
      const workInProgressData = await getUserGridPreference(
        workInProgressModelInfo
      );
      return workInProgressData;
    } catch (error) {
      showSnackbar("Error fetching data", true);
    } finally {
      setLoading(false);
    }
  };

  const handleAgeDaysChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const newAgeDays = event.target.value as string;
    setSelectedAgeDays(newAgeDays);
  };

  //Ok button
  const handleOk = () => {
    if (selectedAgeDays !== "All") {
      ageDay = parseInt(selectedAgeDays);
    } else {
      ageDay = null;
    }
    const params: WorkInprogressModelDetails = {
      AgeDays: ageDay,
      workInprogressModelDetails: [],
      UnmatchedAssetNamesDelete: [],
      UnmatchedAssetIds: [],
      ModifiedBy: 0,
      contextName: LocalStorageUtil.getItem("contextName")?.toString(),
    };
    getData(params);
  };

  //#region
  //Quick Filter
  const onFilterTextBoxChanged = useCallback(() => {
    debugger;
    const filterText = (
      document.getElementById("filter-text-box") as HTMLInputElement
    ).value;

    gridRef.current?.api.setGridOption("quickFilterText", filterText);
  }, []);
  //#endregion

  return (
    <div>
      <NavigationBar  menuTitle="Queue Managment" screenTitle="" title="Work InProgress" text="Work InProgress" />
      <Row style={{ margin: "1em" }}>
        <Col xs={12}>
          <Box>
            <div className="rp-main-inner col-sm-12">
              <div
                className="queue-top row clearfix"
                style={{ marginTop: "-.5em" }}
              >
                <div
                  className="col-sm-7"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--aggrid-text-color)",
                    fontWeight: 600,
                    fontSize: "11px",
                    gap: "1em",
                  }}
                >
                  {" "}
                  Age(Days)
                  <div className="col-sm-3">
                    <select
                      id="list-field"
                      value={selectedAgeDays}
                      style={{
                        paddingTop: "0px",
                        backgroundColor: "white",
                        display: "inline-block !important",
                        alignItems: "center",
                        width: "30ch",
                        marginLeft: "6px",
                        height: "25px",
                        fontSize: "11px",
                      }}
                      onChange={handleAgeDaysChange}
                    >
                      <option aria-label="None" value="">
                        Select
                      </option>
                      {ageDays.map((option) => (
                        <option
                          key={option.value}
                          value={option.value}
                          style={{ fontSize: "11px" }}
                        >
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleOk}
                    className="button ok-button"
                  >
                    Ok
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    className="button clear-button"
                    onClick={handleClear}
                  >
                    Clear
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    className="button delete-button"
                    onClick={handleDeleteClick}
                  >
                    Delete
                  </Button>
                  {gridRecordExist && (
                    <input
                      type="text"
                      id="filter-text-box"
                      placeholder="Quick Filter..."
                      onInput={onFilterTextBoxChanged}
                      style={{
                        width: "25em",
                        height: "2.5em",
                        fontSize: "11px",
                        paddingLeft: ".5em",
                        marginBottom: ".1em",
                      }}
                    />
                  )}
                </div>
                <div
                  className="col-sm-5"
                  style={{
                    display: "flex",
                    gap: ".1em",
                    alignItems: "center",
                    justifyContent: "right",
                  }}
                >
                  {gridRecordExist && (
                    <>
                      <Tooltip title="Click to save grid state">
                        <IconButton
                          onClick={handleSaveGridPreferences}
                          className="preference-icon"
                        >
                          <PushPinIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Click to export the grid content in excel">
                        <button
                          type="button"
                          onClick={handleExport}
                          style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                          aria-label="Export to Excel"
                        >
                          <img
                            src={ExcelIcon}
                            alt="Export to Excel"
                            className="excel-icon"
                            style={{ pointerEvents: "none" }}
                            tabIndex={-1}
                          />
                        </button>
                      </Tooltip>
                    </>
                  )}
                </div>
              </div>
              <div className="rp-main-inner col-sm-12">
                <div className="queue-table-view clearfix">
                  <div
                    className="ag-theme-quartz-dark"
                    style={{
                      height:"73vh",
                      marginTop: ".5em",
                    }}
                  >
                    <AgGridReact
                      columnDefs={columnDefs}
                      rowData={rowData}
                      pagination={true}
                      paginationPageSize={defaulPageSize}
                      paginationPageSizeSelector={pageSizeSelector}
                      rowGroupPanelShow="always"
                      pivotPanelShow="always"
                      gridOptions={{
                        rowSelection: {
                          mode: "multiRow",
                          checkboxes: true,
                          headerCheckbox: true,
                          enableClickSelection: false,
                        },
                      }}
                      ref={gridRef}
                      headerHeight={30}
                      overlayLoadingTemplate={
                        '<span class="ag-overlay-loading-center">Loading...</span>'
                      }
                      overlayNoRowsTemplate={
                        '<span class="ag-overlay-loading-center">No rows to show</span>'
                      }
                      loadingOverlayComponentParams={{
                        loadingMessage: "Loading...",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Col>
      </Row>
      {/* Confirmation Dialog */}
      <Dialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          style={{
            backgroundColor: "var(--primary-color)",
            color: "var(--aggrid-text-color)",
          }}
          id="alert-dialog-title"
        >
          {"Confirm Delete"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete the selected records? This action
            cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default WorkInProgress;
